import App from './login/Router.svelte';

const app = new App({
	target: document.getElementById("page_body"),
	props: {}
});

export default app;
